

module.exports = __webpack_require__.stylable.create(
    "List1584463848",
    {"classes":{"root":"List1584463848__root","textAlignmentMixin":"List1584463848__textAlignmentMixin","header":"List1584463848__header","title":"List1584463848__title","subtitle":"List1584463848__subtitle","disclaimer":"List1584463848__disclaimer","empty":"List1584463848__empty"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    8,
    "List1584463848",
    null
);
